import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { PlatformModule } from '../models/platform-module';
import { Subject } from 'rxjs';
import { Environment } from '../models/environment';
import { EnvironmentService } from '../services/environment.service';

@Component({
    selector: 'app-navmenu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css'],
    standalone: false
})
export class NavmenuComponent implements OnInit, OnDestroy {
  environment: Environment;
  peekDeadLetterEnabled: boolean;
  releaseReportEnabled: boolean;
  releaseNotesEnabled: boolean;
  releasesEnabled: boolean;
  announcementEnabled: boolean;
  mods: Array<PlatformModule> = [];

  private readonly _destroying$ = new Subject<void>();

  get enabledMods() {
    return this.mods.filter((item) => item.enabled);
  }

  constructor(
    @Inject(EnvironmentService) private readonly environmentService: EnvironmentService
  ) {
    this.environment = this.environmentService.getEnvironment();
    this.peekDeadLetterEnabled = this.environment.featureToggles.peekDeadLetterEnabled === 'true';
    this.releaseReportEnabled = this.environment.featureToggles.releaseReportEnabled === 'true';
    this.releaseNotesEnabled = this.environment.featureToggles.releaseNotesEnabled === 'true';
    this.releasesEnabled = this.environment.featureToggles.releasesEnabled === 'true';
    this.announcementEnabled = this.environment.featureToggles.announcementsEnabled === 'true';

    this.mods = [
      {
        name: 'Release Report',
        route: 'releasereport',
        enabled: this.releaseReportEnabled,
        iconClass: "material-symbols-outlined",
        icon: "description",
      },
      {
        name: 'Release Notes',
        route: 'releasenotes',
        enabled: this.releaseNotesEnabled,
        iconClass: "material-symbols-outlined",
        icon: "speaker_notes",
      },
      {
        name: 'Releases',
        route: 'releases',
        enabled: this.releasesEnabled,
        iconClass: "material-symbols-outlined",
        icon: "fact_check",
      },
      {
        name: 'RC Jit Access',
        route: 'rcjit',
        enabled: true,
        iconClass: undefined,
        icon: "lock_open",
      },
      {
        name: 'Classic Release Migration',
        route: 'classic-release-migration',
        enabled: true,
        iconClass: 'material-symbols-outlined',
        icon: 'transform',
      },
      {
        name: 'Delete Branch',
        route: 'delete-branch-pr',
        enabled: true,
        iconClass: 'material-symbols-outlined',
        icon: 'delete_sweep',
      },
      {
        name: 'Mario',
        route: 'mario',
        enabled: true,
        iconClass: "material-symbols-outlined",
        icon: "compare_arrows"
      },
      {
        name: 'OneTimeSecret',
        route: 'oneTimeSecret',
        enabled: false,
        iconClass: undefined,
        icon: "",
      },
      {
        name: 'Project Generator',
        route: 'projectgenerator',
        enabled: true,
        iconClass: "material-symbols-outlined",
        icon: "create_new_folder",
      },
      {
        name: 'Peek DeadLetter',
        route: 'deadletter',
        enabled: this.peekDeadLetterEnabled,
        iconClass: "material-symbols-outlined",
        icon: "mystery",
      },
      {
        name: 'Feature Flags',
        route: 'featureflags',
        enabled: true,
        iconClass: "material-symbols-outlined",
        icon: "rocket",
      },
      {
        name: 'Team Metrics',
        route: 'metrics',
        enabled: true,
        iconClass: "material-symbols-outlined",
        icon: "analytics",
      },
      {
        name: 'Ownership Stats',
        route: 'ownership-stats',
        enabled: true,
        iconClass: "material-symbols-outlined",
        icon: "corporate_fare",
      }
      // ,
      // {
      //   name: 'Alerts Breakdown',
      //   route: 'alerts-breakdown',
      //   enabled: true,
      //   iconClass: "material-symbols-outlined",
      //   icon: "bar_chart",
      // }
    ];
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
